export default "__VITE_ASSET__Dgre5Xlp__"